"use client";

import dynamic from "next/dynamic";
import type { ActivityControllerProps } from "@features/proposals/controllers/activity-controller";

export const LazyActivityController = dynamic<ActivityControllerProps>(
  () =>
    import("@features/proposals/controllers/activity-controller").then(
      (mod) => mod.ActivityController,
    ),
  { ssr: false },
);
